<template lang="html">

  <div class="premios">

    <section class="full-view-intro -middle column-center" :data="id" :style="`background:url(/static/img/productos/${id}/background-intro-premios.jpg) center bottom/cover`">

      <h1 class="title -intro" v-html="$t(`productos.${id}.nombre`)"></h1>

      <h2 class="subtitle-intro">{{$t('vistas.premios')}}</h2>

    </section>

    <section class="cuerpo-premios container" v-if="id != ''">



      <h3 class="title -xs" v-html="$t(`productos.${id}.premios.titulo`)"></h3>

      <div class="premios-list row-start">

        <article :active="el[0] == selected" v-for="(el,key) in premios" class="premio-el row-start animation-el" :id="el[0]">

          <div class="contenedor-imagen row-center">
            <img :src="`/static/img/productos/${id}/premios/${el[0]}.png`" alt="">
          </div>
          {{ el[0] }}
          <div class="texto">
            <h3 class="titulo">{{el[1].anyo}} - {{el[1].titulo}}</h3>
            <p class="cuerpo">{{el[1].texto}}</p>
          </div>

        </article>

      </div>

      <router-link class="btn" :to="`${$t(`enlaces.${id}`)}#banner-premios`">
        <span>{{$t('volver_a')}} {{$t(`productos.${id}.nombre`)}}</span>
      </router-link>

    </section>

  </div>

</template>

<script lang="js">

  require('waypoints/lib/noframework.waypoints.js')

  import {mapGetters} from 'vuex';

  export default  {
    name: 'premios',
    data(){
      return {
        id : '',
        selected : ''
      }
    },
    mounted(){

      this.setID();

      if(!!this.$route.hash){
        let hash = this.$route.hash;
        this.selected = hash.split("#")[1];
        // $('html, body').animate({
        //   scrollTop: $(hash).position().top - ($(window).height() / 2)
        // }, 1000);
      }

      setTimeout( e => {
        this.waypoints();
      },100)



    },
    methods : {
      waypoints : function() {
        var waypoints = document.getElementsByClassName('animation-el');
        for (var i = 0; i < waypoints.length; i++) {
          new Waypoint({
            element: waypoints[i],
            offset : '80%',
            handler: function() {
              this.element.classList.add("launched")  
            }
          });
        }
      },
      setID : function(){
        let params = {
          "vino" : "vino",
          "cava" : "cava",
          "aceite" : "aceite",
          "azafran" : "azafran",
          "wine" : "vino",
          "sparkling-wine" : "cava",
          "olive-oil" : "aceite",
          "saffron" : "azafran",
        }

        this.id = params[this.$route.params.id];
      }
    },
    computed :{
      ...mapGetters({
        texts : 'getTexts'
      }),
      premios : function(){
        let premios = this.texts.productos[this.id].premios.premios;
        premios = Object.entries(premios);
        return premios.sort(function (a, b) {
          return (a[1].anyo - b[1].anyo)
        })
      }
    }
  }
</script>

<style scoped lang="scss">

  @import "@/assets/css/colors.scss";

  .premios{
    background: #000;
    color: white;
    .btn{
      margin-bottom: 80px;
    }
  }

  .cuerpo-premios{
    padding-top:75px;
    padding-bottom: 50px;

    .title{
      text-align: center;
      padding-bottom: 20px;
      margin-bottom: 20px;

      &::before{
        display:inline-block;
        left: 50%;
        margin-left: -25px;
      }
    }

    .premios-list{
      margin-top: 40px;
      margin-bottom: 50px;
    }

    .premio-el{
      width: calc(50% - 40px);
      padding: 25px 15px;
      color: black;
      position: relative;
      overflow: hidden;

      &[active=true]{
        border: 1px solid white;
      }

      &:nth-child(2n-1){
        margin-right: 80px;
      }

      .contenedor-imagen{
        width: 140px;
        height: 140px;
        opacity: 0;
        transform: translateX(-200px);
        transition: .8s 0s transform, 1.2s 0s opacity;
        transition-timing-function: ease-in-out;
        img{
          max-width: 100%;
          max-height: 100%;
        }
      }

      .texto{
        width: calc(100% - 140px);
        padding-left: 20px;

        .titulo{
          width: 100%;
          font-size: 20px;
          line-height: 30px;
          font-weight: 600;
          color:$white;
          display: inline-block;
          text-align: left;
          opacity: 0;
          transform: translateY(-50px);
          transition: .8s;
        }

        p{
          text-align: justify;
          font-weight: 400;
          font-size: 14px;
          color: $white;
          opacity: 0;
          transform: translateY(50px);
          transition: .8s;
        }

      }

      &:nth-child(2n){
        .contenedor-imagen, .titulo, p{
          transition-delay: .5s;
        }
      }

      &:nth-child(2n+1){
        .contenedor-imagen, .titulo, p{
          transition-delay: .8s;
        }
      }
      &:nth-child(2n+2){
        .contenedor-imagen, .titulo, p{
          transition-delay: 1s;
        }
      }

      &.launched{
        .contenedor-imagen{
          opacity: 1;
          transform: translate(0);
        }
        .titulo{
         opacity: 1;
         transform: translate(0); 
       }
       p{
        opacity: 1;
        transform: translate(0);
      }
    }

  }
}

@media screen and (max-width: 1023px){
  .cuerpo-premios{
    padding-top: 50px;

    .premio-el{
      width: 100%;
      &:nth-child(2n-1){
        margin-right: 0;
      }
    }
  }
}

@media screen and (max-width: 767px){
  .cuerpo-premios{

    .premio-el{
      padding: 15px 0;
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
      margin-bottom: 20px;
      .texto{
        width: 100%;
        padding-left: 0;
        margin-top: 15px;
        .titulo{
          width: 100%;
          text-align: center;
        }
        .cuerpo{
          text-align: center;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/productos/premios.vue